var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_34",
    "data-name": "Group 34",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.101,
    height: 35.1,
    viewBox: "0 0 35.101 35.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M5999.839,97.071a17.55,17.55,0,1,1,17.552-17.55A17.57,17.57,0,0,1,5999.839,97.071Zm0-33.911A16.361,16.361,0,1,0,6016.2,79.52,16.378,16.378,0,0,0,5999.839,63.16Z",
    transform: "translate(-5982.29 -61.971)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(13.46 9.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M6001.447,75.208l-.2,2.537h-2.6v8.812h-3.286V77.745h-1.752V75.208h1.752V73.5a4.551,4.551,0,0,1,.565-2.627,3.121,3.121,0,0,1,2.721-1.276,11.041,11.041,0,0,1,3.143.315l-.438,2.6a5.935,5.935,0,0,0-1.413-.21c-.681,0-1.292.244-1.292.925v1.981Z",
    transform: "translate(-5993.612 -69.602)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup34);
export default __webpack_public_path__ + "static/media/Group 34.b78e5839dc27a0fee586bf4d596b4ec3.svg";
export { ForwardRef as ReactComponent };